import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import {/*TranslateService,*/ provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import { Configuration, ApiModule } from './generated';
import {environment} from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    [provideRouter(routes)],
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),
    ApiModule, // registers generated APIs
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          //basePath: 'http://localhost:7000/api/v1' // TODO: to come from environment variable
          basePath: environment.apiBaseUrl
        })
    },
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:'./assets/i18n/', suffix:'.json'}),
      fallbackLang: 'en'
    }),
    //TranslateService, // provide TranslateService manually
  ],
};
